const portalGateway = 'soma-dev-portal-api.azurewebsites.net';

export const GATEWAY_SOMA_PORTAL_V1 = `https://${portalGateway}/api/v1`;

export const environment = {
    production: false,
    ENV_NAME: 'default',
    LEGAL_PERSON_BASE: `${GATEWAY_SOMA_PORTAL_V1}/legalPerson`,
    PEOPLE_BASE: `${GATEWAY_SOMA_PORTAL_V1}/people`,
    TENANT_BASE: `${GATEWAY_SOMA_PORTAL_V1}/tenants`
};